(ns common.widgets.scroll
  ;; TODO: Deprecate and replace this ns
  (:require [common.debouncer :as debouncer]
            [reagent.core :as r]))

(defn- get-scroll-top [el]
  (cond
    el (.-scrollTop el)

    (exists? (.-pageYOffset js/window)) (.-pageYOffset js/window)

    :else (.-scrollTop (or (.-documentElement js/document)
                           (.-parentNode (.-body js/document))
                           (.-body js/document)))))

(defn get-el-top-position [node]
  (if (not node)
    0
    (+ (.-offsetTop node) (get-el-top-position (.-offsetParent node)))))

(defn- safe-component-mounted? [el]
  (try (boolean el) (catch js/Object _ false)))

(defn infinite-scroll
  "A component that if scrolled past it and `can-show-more?` is true
  fires the `load-fn` when the scrolled past the div"
  [_props]
  (let [el (atom nil)
        el-ref-fn #(reset! el %)
        unregister-event-listeners-fn (atom nil)
        detach-scroll-listener (fn []
                                 (when (some? @unregister-event-listeners-fn)
                                   (@unregister-event-listeners-fn)
                                   (reset! unregister-event-listeners-fn nil)))
        should-load-more? (fn [this]
                            (let [{:keys [parent-id]} (r/props this)
                                  node @el
                                  parent-node (when parent-id (.querySelector js/document (str "#" parent-id)))
                                  my-top (get-el-top-position node)
                                  scroll-top (get-scroll-top parent-node)
                                  parent-top (get-el-top-position parent-node)
                                  container-height (if parent-node
                                                     (.-offsetHeight parent-node)
                                                     (.-innerHeight js/window))
                                  threshold 50]
                              (< (- (+ my-top (.-offsetHeight node))
                                    scroll-top
                                    parent-top
                                    container-height)
                                 threshold)))
        scroll-listener (fn [this ^js _event]
                          (when (safe-component-mounted? @el)
                            (let [{:keys [load-fn can-show-more?]} (r/props this)]
                              (when (and can-show-more?
                                         (should-load-more? this))
                                (detach-scroll-listener)
                                (load-fn)))))
        debounce (debouncer/make-debouncer 200)
        attach-scroll-listener (fn [this]
                                 (let [{:keys [parent-id can-show-more?]} (r/props this)
                                       parent-node (when parent-id (.querySelector js/document (str "#" parent-id)))
                                       target (or parent-node js/window)]
                                   (when can-show-more?
                                     (when (nil? @unregister-event-listeners-fn)
                                       (let [debounced-scroll-listener (debounce scroll-listener this)]
                                         (.addEventListener target "scroll" debounced-scroll-listener)
                                         (.addEventListener target "resize" debounced-scroll-listener)
                                         (reset! unregister-event-listeners-fn
                                                 (fn []
                                                   (.removeEventListener target "scroll" debounced-scroll-listener)
                                                   (.removeEventListener target "resize" debounced-scroll-listener))))))))]
    (r/create-class
     {:component-did-mount
      (fn [this]
        (attach-scroll-listener this))
      :component-did-update
      (fn [this _]
        (attach-scroll-listener this))
      :component-will-unmount
      detach-scroll-listener
      :reagent-render
      (fn [_props]
        [:div
         {:ref el-ref-fn}])})))
